<template>
  <div class="container">
    <vxe-form
        ref="xForm"
        class="my-form2"
        title-align="right"
        :data="formData"
        :rules="formRules"
        title-width="100"
        prevent-submit>

      <vxe-form-item title="合同编号" field="contractSn" span="12">
        <template v-slot="scope">
          <vxe-input v-model="formData.contractSn" placeholder="请输入合同编号" clearable
                     @input="$refs.xForm.updateStatus(scope)" style="width: 300px;"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="合同名称" field="docTitle" span="12">
        <template v-slot="scope">
          <vxe-input v-model="formData.docTitle" placeholder="请输入合同名称" clearable
                     @input="$refs.xForm.updateStatus(scope)" style="width: 300px;"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="发起方" field="companyId" span="12">
        <template>
          <div class="input-border" style="display: flex;align-items: center;">
            <platform-corp
                class="corp"
                :row="formData"
                :field="'company'"
                :placeholder="'请选择平台企业'"
            ></platform-corp>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="签署方" field="otherName" span="12">
        <template>
          <div class="input-border">
            <a target="_black" @click="openChooseAccount('customerName')">
              {{ formData.otherName ? formData.otherName : "请选择客户名称" }}
            </a>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="生效日期" field="effectiveTime" span="12">
        <vxe-input type="date" v-model="formData.effectiveTime"
                   placeholder="请选择日期" style="width: 300px;"></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="终止日期" field="expirationTime" span="12">
        <vxe-input type="date" v-model="formData.expirationTime"
                   placeholder="请选择日期" style="width: 300px;"></vxe-input>
      </vxe-form-item>
      <!--      <vxe-form-item title="签署关键字" field="signKeyword" span="12">-->
      <!--        <template v-slot="scope">-->
      <!--          <div style="display: flex;flex-direction: column">-->
      <!--            <vxe-input v-model="formData.signKeyword" placeholder="请输入签署关键字" clearable-->
      <!--                       @input="$refs.xForm.updateStatus(scope)" style="width: 300px;margin-top: 20px;"></vxe-input>-->
      <!--            <span-->
      <!--                style="height: 16px;font-size: 12px;font-family: Microsoft YaHei,serif;font-weight: 400;line-height: 16px;color: #CCCCCC;">(客户签章会盖在指定关键字处)</span>-->
      <!--          </div>-->

      <!--        </template>-->
      <!--      </vxe-form-item>-->
      <!--      <vxe-form-item title="签署策略" field="keywordStrategy" span="12">-->
      <!--        <template>-->
      <!--          <div style="height: 70px;display: flex;align-items: center;">-->
      <!--            <vxe-select v-model="formData.keywordStrategy" placeholder="请选择签署策略" :options="tactics" transfer-->
      <!--                        style="width: 300px;"></vxe-select>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--      </vxe-form-item>-->
      <vxe-form-item title="合同文件" field="docUrl" span="12">
        <div v-show="formData.docUrl" class="input-border" style="display: flex;align-items: center;">
          <img style="height: 42px;width: 42px;" src="~assets/images/common/upload-icon.png"/>
          <span style="font-size: 14px;font-family: Microsoft YaHei,sans-serif;font-weight: 400;color: #1A8CFE;">{{formData.docName}}</span>
          <img style="height: 10px;width: 10px;" src="~assets/images/common/close.png" @click="handleRemove"/>
        </div>
        <Upload
            v-show="!formData.docUrl"
            style="width: 300px;"
            ref="upload"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :before-upload="handleUpload"
            :on-success="loadfile"
            :action="actionUrl"
            :headers="uploadHeaders"
            accept=".pdf">
          <div>
            <div class="input-border" style="display: flex;align-items: center;">
              <img style="width: 14px;height: 14px;margin-left: 21px" src="~assets/images/common/upload.png"/>
              <span
                  style="margin-left:2px;font-size: 14px;font-family: Microsoft YaHei,sans-serif;font-weight: 400;color: #CCCCCC;">上传合同附件</span>
            </div>
          </div>
        </Upload>
      </vxe-form-item>
    </vxe-form>
    <div class="modal-footer add-btn-box">
      <Button @click="close" style="width: 100px;">取 消</Button>
      <Button status="primary" @click="commit" style="width: 100px;">发起签署</Button>
    </div>
    <vxe-modal v-model="isShowChooseAccount" width="800" height="600" resize remember
               title="客户名称">
      <account @choose="chooseAccountEvent" ref="Account"></account>
    </vxe-modal>
  </div>
</template>
<script>
  import Account from '@/components/modal/Account';
  import PlatformCorp from "@/components/common/PlatformCorp";
  import auth from "@/utils/auth";
  import {hideLoading, showLoading} from "@/utils/util";
  import $api from "@/apiProvider";
  import Auth from "@/utils/auth";

  export default {
    name: "CreateEleModal",
    components: {Account, PlatformCorp},
    data() {
      let userInfoValue = {};
      if (Auth.isLogin()) {
        userInfoValue = Auth.getAuth();
      }
      return {
        userInfoValue,
        isShowChooseAccount: false,
        currentChoose: '',
        isInit: false,
        actionUrl: "",
        defaultList: [],
        uploadHeaders: {
          Authorization: auth.getAuth().token,
          token: auth.getAuth().token,
        },
        formData: {
          id: null,
          contractSn: null,
          docTitle: null,
          company: null,
          companyId: null,
          otherName: null,
          otherUserId: null,
          effectiveTime: null,
          expirationTime: null,
          signKeyword: null,
          keywordStrategy: null,
          docUrl: null,
          docName: null,
        },
        isEdit: false,
        type: 0,
        formRules: {
          docTitle: [{required: true, message: "请输入合同名称"}],
          companyId: [{required: true, message: "请选择平台企业"}],
          otherName: [{required: true, message: "请选择客户"}],
          effectiveTime: [{required: true, message: "请选择日期"}],
          expirationTime: [{required: true, message: "请选择日期"}],
          docUrl: [{required: true, message: "请上传合同"}],
        },
        tactics: [
          {
            label: '所有关键字位置',
            value: 1,
          }, {
            label: '第一处关键字位置',
            value: 2,
          },
          {
            label: '最后一处关键字位置',
            value: 3,
          }
        ]
      };
    },
    mounted() {
      this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
    },
    methods: {
      commit() {
        if (this.isEdit) {
          this.update();
        } else {
          this.save();
        }
      },
      showDetail(id) {
        this.isEdit = true;
        this.detail(id);
      },
      async validEvent() {
        let errMap = await this.$refs.xForm.validate().catch((errMap) => errMap);
        return errMap ? false : true;
      },
      async save() {
        let sts = await this.validEvent();
        if (!sts) {
          return;
        }
        showLoading();
        let obj = Object.assign({}, this.formData);
        obj.sponsorName = obj.company;
        obj.effectiveTime = this.$utils.timestamp(obj.effectiveTime);
        obj.expirationTime = this.$utils.timestamp(obj.expirationTime);
        obj.createUserId = this.userInfoValue.id;
        let res = await $api.eleContract.request("create", obj);
        hideLoading();
        if (res.status === 1) {
          this.reset();
          this.close();
          this.getCompSignUrl(res.data);
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async update() {
        let sts = await this.validEvent();
        if (!sts) {
          return;
        }
        showLoading();
        let obj = Object.assign({}, this.formData);
        obj.sponsorName = obj.company;
        obj.effectiveTime = this.$utils.timestamp(obj.effectiveTime);
        obj.expirationTime = this.$utils.timestamp(obj.expirationTime);
        let res = await $api.eleContract.request("update", obj);
        hideLoading();
        if (res.status === 1) {
          this.reset();
          this.close();
          this.getCompSignUrl(res.data);
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async getCompSignUrl(id) {
        showLoading();
        let res = await $api.eleContract.post("getCompSignUrl", {
          id: id,
          returnUrl: process.env.VUE_APP_LOGIN + '/agreement/eleContract'
        });
        hideLoading();
        if (res.status === 1) {
          window.location.href = res.data;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async detail(id) {
        showLoading();
        let res = await $api.eleContract.post("detail", {
          id: id
        });
        hideLoading();
        if (res.status === 1) {
          let data = res.data;
          data.effectiveTime = this.$utils.toDateString(data.effectiveTime, "yyyy-MM-dd");
          data.expirationTime = this.$utils.toDateString(data.expirationTime, "yyyy-MM-dd");
          data.company = data.sponsorName;
          this.formData = data;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      reset() {
        this.formData = {
          id: null,
          contractSn: null,
          docTitle: null,
          company: null,
          companyId: null,
          otherName: null,
          otherUserId: null,
          effectiveTime: null,
          expirationTime: null,
          signKeyword: null,
          keywordStrategy: null,
          docUrl: null,
          docName: null,
        };
        this.isEdit = false;
        this.$refs.xForm.clearValidate();
      },
      close() {
        this.reset();
        this.$emit('close');
      },
      openChooseAccount(field) {
        this.isShowChooseAccount = true;
        this.currentChoose = field;
        this.$refs.Account.init()
      },
      chooseAccountEvent(account, type) {
        if (type === 2) {
          this.formData.otherName = account.realName;
        } else {
          this.formData.otherName = account.compName;
        }
        this.formData.otherUserId = account.id;

        this.isShowChooseAccount = false
        this.$refs.xForm.clearValidate();
      },
      handleUpload(file) {
        showLoading();
        this.file = file;
        let that = this;
        let reader = new FileReader();
        reader.onload = function (e) {
          that.imgUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      },
      loadfile(res) {
        hideLoading();
        if (res && res.status === 200 && res.data) {
          this.formData.docUrl = res.data.url;
          this.formData.docName = res.data.oldName;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      handleRemove() {
        this.formData.docUrl = null;
        this.formData.docName = null;
      },
    }
  }

</script>
<style scoped>
  .container {
    background: grey;
  }

  .input-border {
    border: 1px solid #dcdfe6;
    width: 300px;
    height: 34px;
    border-radius: 4px;
    padding: 0 .6em;
  }

  .input-border a, .input-border span {
    cursor: pointer;
    display: inline-block;
    width: 100%;
    line-height: 34px;
  }

  .modal-footer {
    box-sizing: border-box;
    padding: 10px 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 98%;
    position: absolute;
    bottom: 0;
  }

  .corp >>> .link-text {
    color: #2D8CF0;
    font-size: 14px;
    font-family: Roboto, sans-serif;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>